import { render, staticRenderFns } from "./DigiProducts.vue?vue&type=template&id=77348248"
import script from "./DigiProducts.vue?vue&type=script&lang=js"
export * from "./DigiProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports